import Vue from 'vue';
import Vuex from 'vuex';

import { ref } from './ref';
import { auth } from './auth';
import { createAccount } from './createAccount';
import { applicantInfo } from './applicantInfo';
import { officerConfig } from './officerConfig';
import { announcement } from './announcement';
import { params } from './params';
import { keycloak } from './keycloak';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        ref,
        createAccount,
        applicantInfo,
        officerConfig,
        announcement,
        params,
        keycloak,
    }
});